import { Col, Row } from "antd";
import { useGetFormStructureQuery } from "api/TenantSlug/FormStructure/hooks.ts";
import { COMMON_GET_FORM_STRUCTURE_QUERY_FILTERS } from "api/TenantSlug/FormStructure/queryOptions.ts";
import { FormStructureGeneralForm } from "components/Forms/FormStructureGeneralForm/FormStructureGeneralForm.tsx";
import { QueryState } from "components/UI/QueryState/QueryState.tsx";
import { SectionContentWrapper } from "components/UI/SectionContentWrapper";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { FormId } from "types/models.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getToolStructureLeadHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/lead/_layout/$formStructureId/_layout/general/"
)({
    component: LeadStructureGeneralPage,
    staticData: {
        permissions: [PermissionEnum.ToolStructureFormGeneral],
        showInSideMenu: false,
        label: "pages.tool.structure.lead.general.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.tool.structure.lead.general.title"),
        };
    },
});

function LeadStructureGeneralPage() {
    const { formStructureId } = Route.useParams();
    const { data, isLoading, isError } = useGetFormStructureQuery(
        formStructureId,
        COMMON_GET_FORM_STRUCTURE_QUERY_FILTERS
    );
    const formStructure = data?.formStructure;

    if (!formStructure) {
        return (
            <QueryState
                isLoading={isLoading}
                isError={isError || !isLoading}
                errorKey="errors.loading_form_structure"
            />
        );
    }

    return (
        <TenantPage
            headerNavigationItems={getToolStructureLeadHeaderItems}
            isEdit={true}
            saveFormId={FormId.FormStructureForm}
        >
            <Row>
                <Col span={12}>
                    <SectionContentWrapper withBackground>
                        <FormStructureGeneralForm key={formStructureId} formStructure={formStructure} />
                    </SectionContentWrapper>
                </Col>
            </Row>
        </TenantPage>
    );
}
